import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
import { Count } from 'Src/models/count';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';

export type FormTemplateTag = {
  id: string;
  schoolId?: string;
  tagName: string;
  color: string;
};

export type FormTemplateTagPayload = {
  tagName: string;
  color: string;
};

const configFor = (user: AppUser) => ({ headers: { usid: user.roleSessionKey } });

export function getAllFormTemplateTags(user: AppUser): Promise<FormTemplateTag[]> {
  return axios
    .get<FormTemplateTag[]>(`${window.apiBase}/i/schools/${user.activeSchoolId}/formTemplateTags`, {
      ...configFor(user),
      params: {
        filter: {
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    })
    .then(response => response.data);
}

export function getFormTemplateTagsCount(user: AppUser): Promise<Count> {
  return axios
    .get<Count>(`${window.apiBase}/i/schools/${user.activeSchoolId}/formTemplateTags/count`, configFor(user))
    .then(response => response.data);
}

export function createFormTemplateTag(user: AppUser, data: FormTemplateTagPayload): Promise<FormTemplateTag> {
  return axios
    .post<FormTemplateTag>(`${window.apiBase}/i/schools/${user.activeSchoolId}/formTemplateTags`, data, configFor(user))
    .then(response => response.data);
}

export function updateFormTemplateTag(
  user: AppUser,
  tagId: string,
  data: FormTemplateTagPayload
): Promise<FormTemplateTag> {
  return axios
    .put<FormTemplateTag>(`${window.apiBase}/i/schools/${user.activeSchoolId}/formTemplateTags/${tagId}`, data, configFor(user))
    .then(response => response.data);
}

export function deleteFormTemplateTag(user: AppUser, tagId: string): Promise<void> {
  return axios
    .delete(`${window.apiBase}/i/schools/${user.activeSchoolId}/formTemplateTags/${tagId}`, configFor(user))
    .then(response => response.data);
}
